var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBlockCheckoutIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5.667 14.875a.54.54 0 0 1-.542-.542V5.667c0-.3.242-.542.542-.542h3.25c.299 0 .541.243.541.542v8.666c0 .3-.242.542-.541.542zm.541-1.083h2.167V6.208H6.208zM11.49 10.471l1.58 1.862-.566.667-2.546-3 2.546-3 .566.667-1.58 1.862h4.468v.942z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  d: "m14.938 2.296 1.916 1.607L5.346 17.616 3.431 16.01z"
})));
export { SvgBlockCheckoutIcon as ReactComponent };
export default __webpack_public_path__ + "e54676259bc8f6c95c961ac35633ab79.svg";